export default __webpack_public_path__ + "logo-appstore-6cf90c61422a6e65312f2a03efee1ece.svg";